import styled from "styled-components";

import QuoteMark from '../../assets/icons/BPS Icon - Quote.png';

const QuoteSection = styled.div`
    background-color: #f0f4fa;
    font-size: 1.25rem;
    color: #1c304c;
    font-weight: bold;
    font-family: 'Mulish', sans-serif !important;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;

    div {
        font-weight: normal;
        color: #4d4d4d;
        font-size: 1.125rem;
    }
`
const Quote = styled.div`
    font-size: 1.25rem !important;
    color: #1c304c !important;
    font-weight: bold !important;
    font-family: 'Mulish', sans-serif !important;
    text-align: center !important;

    div {
        font-weight: normal;
        color: #4d4d4d;
        font-size: 1.125rem;
    }
`

const QuotationMark = () => {
    return (
        <>

            <img src={QuoteMark} width={80} className='pb-5 mx-auto text-center' />

        </>
    );
}


export { QuoteSection, Quote, QuotationMark }
